import {
	Badge,
	Card,
	CardHeader,
	CardFooter,
	CardPreview,
	makeStyles,
	Body1Strong
} from '@fluentui/react-components';
import { StoryCardProps } from './types';
import { useLazyFetchGameDetailsQuery } from '../Api/Games/gamesSlice';
import { useEffect, useState } from 'react';
import { ResourceTypes } from '../Api/Story/types';
import { useLazyFetchReviewsQuery } from '../Api/Reviews/reviewSlice';

const useStyles = makeStyles({
	card: {
		margin: 'auto',
		width: '720px',
		maxWidth: '100%'
	},
	image: {
		maxHeight: '300px',
		width: 'auto',
		objectFit: 'cover'
	},
	header: {
		display: 'flex',
		justifyContent: 'space-between'
	}
});

export default function StoryCard(props: StoryCardProps) {
	const styles = useStyles();
	const [imageUrl, setImageUrl] = useState<string | undefined>();
	const { resourceType, linkId } = props.story;

	const [fetchGame, { data: gameDetails }] = useLazyFetchGameDetailsQuery();
	const [fetchReview, { data: reviewDetails }] = useLazyFetchReviewsQuery();

	useEffect(() => {
		switch (resourceType) {
			case ResourceTypes.Game:
				void fetchGame(linkId);
				break;
			case ResourceTypes.Review:
				void fetchReview({ reviewId: linkId });
				break;
			case ResourceTypes.Story:
				break;
			default:
				break;
		}
	}, [resourceType, linkId, fetchGame, fetchReview]);

	useEffect(() => {
		if (gameDetails) {
			setImageUrl(gameDetails.boxArtUrl);
		}
		if (reviewDetails) {
			setImageUrl(reviewDetails[0].videoGameBoxArt);
		}
	}, [gameDetails, reviewDetails]);

	return (
		<Card className={styles.card}>
			<CardHeader
				header={
					<div
						style={{
							display: 'flex',
							columnGap: '5px',
							flexWrap: 'wrap'
						}}
					>
						{props.story.tags.map((tag) => (
							<Badge
								key={props.story.id}
								color={tag.color ?? 'informative'}
								shape='rounded'
								appearance='tint'
							>
								Hot Game
							</Badge>
						))}
						<Body1Strong className={styles.header}>
							{props.story.headline}
						</Body1Strong>
					</div>
				}
				description={<></>}
			></CardHeader>

			<CardPreview>
				<img
					className={styles.image}
					src={imageUrl}
					alt='Story Card'
				/>
			</CardPreview>

			<CardFooter>{props.story.content}</CardFooter>
		</Card>
	);
}
